import { AdminSettingsSection } from './AdminSettingsSection'

export default AdminSettingsSection
